import { checkIsInternalCompany } from 'app/auth/authUtils';
import { createSelector } from 'reselect';

import { getIsFromInternalCompany } from 'store/auth/selectors';

import { getProgramsCategory } from './programsCategory.selectors';

const getChannels = createSelector(getProgramsCategory, ({ channels }) => channels);

export const getAllChannels = createSelector(
  [getChannels, getIsFromInternalCompany],
  (channels, isInternalCompany) =>
    Object.values(channels)
      .map(channel => ({
        ...channel,
        isGlobal: !isInternalCompany && checkIsInternalCompany({ companyId: channel.companyId }),
      }))
      .sort((a, b) => a.name.localeCompare(b.name)),
);
